const utils = (context) => {};

const main = (context) => {
  const { dispatch } = context;
  return {
    async updateAllTableBelowAddedRows(range, count) {
      await Promise.all([
        dispatch("table/updateAllTableBelowAddedRows", { range, count }, { root: true }),
        dispatch("table/updateAllNamedRangesBelowAddedRows", { range, count }, { root: true }),
      ]);

      return async () => {
        await Promise.all([
          dispatch(
            "table/updateAllTableBelowAddedRows",
            { range, count: -1 * (range[3] - range[1] + 1) },
            { root: true }
          ),
          dispatch(
            "table/updateAllNamedRangesBelowAddedRows",
            { range, count: -1 * (range[3] - range[1] + 1) },
            { root: true }
          ),
        ]);
      };
    },
    async updateAllTableToLeftAddedColumns(range, count) {
      await Promise.all([
        dispatch("table/updateAllTableToLeftAddedColumns", { range, count }, { root: true }),
        dispatch("table/updateAllNamedRangesToLeftAddedColumns", { range, count }, { root: true }),
      ]);

      return async () => {
        await Promise.all([
          dispatch(
            "table/updateAllTableToLeftAddedColumns",
            { range, count: -1 * (range[2] - range[0] + 1) },
            { root: true }
          ),
          dispatch(
            "table/updateAllNamedRangesToLeftAddedColumns",
            { range, count: -1 * (range[2] - range[0] + 1) },
            { root: true }
          ),
        ]);
      };
    },
  };
};
export default (context) => {
  return {
    main: main(context),
    utils: utils(context),
  };
};
